import React from "react";
import {useLazyQuery, useMutation, useSubscription} from "@apollo/client";
import {QUERY_USERS, USER_WALLET_DATA} from "../registryComponentsGQL.js";
import {Box, Layer, Text} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {GET_WALLET, QUERY_USER_ENTRANCE} from "./UserGQL.js";
import moment from "moment/moment.js";

function LayerEntrances(props){
    const [entranceList,setEntranceList]=React.useState(null);

    const [ queryEntranceList
    ]  = useLazyQuery(QUERY_USER_ENTRANCE, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            console.log("DATA",data);
            if(data["clubmate_entrance_entrance"]){
                setEntranceList(transformData(data));
            }
        },
        onError:(error)=>{
            console.log(error);
        },
        notifyOnNetworkStatusChange: true, // did the work
    });

    React.useEffect(()=>{
        queryEntranceList({variables:{userId:props?.id}})
    },[])

    const transformData = (data) => {
        if (!data) return [];
        return data["clubmate_entrance_entrance"].map((event) => ({
            id: event?.id,
            datetime: moment(event?.datetime).format("DD-MM-YYYY HH:mm:ss"),
            isGuest: event?.is_guest,
            userName: event?.usersregister_userregister?.name +" "+event?.usersregister_userregister?.name+ " "+event?.usersregister_userregister?.fiscal_code,
        }));
    };

    const columnsEntrance = [
        { field: 'datetime', headerName: 'Data e Ora', width: 200 },
        { field: 'isGuest', headerName: 'È un accesso ospite/gara?', width: 200 },
        { field: 'userName', headerName: 'Utente', width: 300 },
    ];


    return (
        <Layer onEsc={props?.onEscLayer} onClickOutside={props?.onEscLayer}>
            <Box margin={"medium"} gap={"medium"} overflow="auto"  height="100%" width="800px" alignSelf='center' style={{marginTop:'40px'}}>
                <div style={{ height: '75vh', width: '800px' }}>
                    <DataGrid
                        rows={entranceList || []}
                        columns={columnsEntrance}
                    />
                </div>
            </Box>
        </Layer>
    )
}

export default LayerEntrances;